import { render, staticRenderFns } from "./VerticalSplitPane.vue?vue&type=template&id=585cc2b8&scoped=true&"
import script from "./VerticalSplitPane.vue?vue&type=script&lang=js&"
export * from "./VerticalSplitPane.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSplitPane.vue?vue&type=style&index=0&id=585cc2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585cc2b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
